<template>
	<div
		v-if="visibleMenuOptions"
		class="admin-section"
		:class="{ 'modal-opened': modalOpened }"
	>
		<ja-header :title="titleHeader" :show-clock="true">
			<template v-slot:icon>
				<svgicon name="dashboard-icon"></svgicon>
			</template>
			<template v-slot:centered-content>
				<svgicon name="clock"></svgicon>
				<div class="clock">
					<ja-clock></ja-clock>
				</div>
			</template>
			<template v-slot:admin-facility>
				<div class="facility-dropdown-container">
					<ja-facilities-dropdown @update="updateTemplates($event)">
					</ja-facilities-dropdown>
				</div>
			</template>
		</ja-header>
		<div class="dashboard-bottom-container">
			<div class="dashboard-bottom">
				<div class="segmented-control-wrapper">
					<ja-segmented-control
						:value="selectedOption"
						:options="visibleMenuOptions"
						@input="onMenuChange"
					></ja-segmented-control>
				</div>
			</div>
			<div v-if="cmsMenuOptionSelected" class="dashboard-bottom">
				<div class="segmented-control-wrapper">
					<ja-segmented-control
						:value="selectedCmsOption"
						:options="visibleCmsMenuOptions"
						@input="onMenuChange"
					></ja-segmented-control>
				</div>
			</div>
		</div>
		<ja-loading-bar v-if="loading"></ja-loading-bar>
		<div ref="menu-view" class="content-wrapper">
			<ja-evaluation-question
				v-if="
					selectedOption == 'cms' &&
						selectedCmsOption == 'cmsEvaluationQuestions'
				"
				v-model="selectedOption"
			>
			</ja-evaluation-question>
			<ja-simulation-template
				v-if="
					selectedOption == 'cms' &&
						selectedCmsOption == 'cmsSimulationTemplates'
				"
				v-model="selectedOption"
			></ja-simulation-template>
			<ja-interest
				v-if="selectedOption == 'cms' && selectedCmsOption == 'cmsInterest'"
				v-model="selectedOption"
			></ja-interest>
			<ja-expense-categories
				v-if="
					selectedOption == 'cms' && selectedCmsOption == 'cmsExpenseCategories'
				"
				v-model="selectedOption"
			></ja-expense-categories>
			<ja-cms-resources
				v-if="selectedOption == 'cms' && selectedCmsOption == 'cmsResources'"
				v-model="selectedOption"
			></ja-cms-resources>
			<ja-life-events
				v-if="selectedOption == 'cms' && selectedCmsOption == 'cmsLifeEvents'"
				v-model="selectedOption"
			></ja-life-events>
			<ja-misc-uploads
				v-if="selectedOption == 'cms' && selectedCmsOption == 'cmsMiscUploads'"
				v-model="selectedOption"
			></ja-misc-uploads>
			<ja-careers
				v-if="selectedOption == 'cms' && selectedCmsOption == 'cmsCareers'"
				v-model="selectedOption"
			></ja-careers>
			<ja-facility-view
				v-if="selectedOption == 'cms' && selectedCmsOption == 'cmsFacility'"
				v-model="selectedOption"
			></ja-facility-view>
			<ja-user-management
				v-if="selectedOption == 'cms' && selectedCmsOption == 'cmsUsers'"
				v-model="selectedOption"
			></ja-user-management>
			<ja-messages
				v-if="selectedOption == 'messages'"
				v-model="selectedOption"
				@loadingStartForAdmin="onLoadingStartForAdmin"
				@loadingStopForAdmin="onLoadingStopForAdmin"
			></ja-messages>
			<ja-students
				v-if="selectedOption == 'students'"
				@loadingStartForAdmin="onLoadingStartForAdmin"
				@loadingStopForAdmin="onLoadingStopForAdmin"
				@modalOpened="onModalOpened"
				@modalClosed="onModalClosed"
			></ja-students>
			<ja-simulation-management
				v-if="selectedOption == 'simulationManagement'"
				@loadingStartForAdmin="onLoadingStartForAdmin"
				@loadingStopForAdmin="onLoadingStopForAdmin"
			></ja-simulation-management>
			<ja-resources
				v-if="selectedOption == 'resources'"
				v-model="selectedOption"
			></ja-resources>
			<ja-reporting
				v-if="selectedOption == 'reporting'"
				v-model="selectedOption"
			></ja-reporting>
			<ja-settings
				v-if="selectedOption == 'settings'"
				v-model="selectedOption"
			></ja-settings>
		</div>
	</div>
</template>

<script>
import '../components/icons/dashboard-icon';
import '../components/icons/clock';

import Messages from '@/components/AdminSection/MenuOptions/Messages';
import Students from '@/components/AdminSection/MenuOptions/Students';
import Resources from '@/components/AdminSection/MenuOptions/Resources';
import SimulationManagement from '@/components/AdminSection/MenuOptions/SimulationManagement';
import Reporting from '@/components/AdminSection/MenuOptions/Reporting';
import Settings from '@/components/AdminSection/MenuOptions/Settings';

import {
	Facility,
	UserManagement,
	EvaluationQuestion,
	SimulationTemplate,
	ExpenseCategories,
	Interest,
	CmsResources,
	LifeEvents,
	MiscUploads,
	Careers
} from '@/components/Cms/components/';
import FacilitiesDropdown from '@/components/AdminSection/elements/MasterFacilitiesDropdown';

import SegmentedControl from '@/components/ui/SegmentedControl';
import Clock from '@/components/AdminSection/elements/Clock';
import Header from '@/components/ui/headers/Header';
import LoadingBar from '@/components/ui/LoadingBar';
import UserData from '@/mixins/UserData';

export default {
	components: {
		jaMessages: Messages,
		jaStudents: Students,
		jaResources: Resources,
		jaSimulationManagement: SimulationManagement,
		jaHeader: Header,
		jaSegmentedControl: SegmentedControl,
		jaClock: Clock,
		jaLoadingBar: LoadingBar,
		jaReporting: Reporting,
		jaSettings: Settings,
		jaFacilitiesDropdown: FacilitiesDropdown,
		jaFacilityView: Facility,
		jaUserManagement: UserManagement,
		jaEvaluationQuestion: EvaluationQuestion,
		jaSimulationTemplate: SimulationTemplate,
		jaExpenseCategories: ExpenseCategories,
		jaInterest: Interest,
		jaCmsResources: CmsResources,
		jaLifeEvents: LifeEvents,
		jaMiscUploads: MiscUploads,
		jaCareers: Careers
	},
	mixins: [UserData],
	props: {
		student: {
			type: Object,
			default: null
		},
		selectedOption: {
			type: String,
			default: 'messages'
		},
		selectedCmsOption: {
			type: String,
			default: 'evaluationQuestions'
		}
	},

	data() {
		return {
			menuCmsOptions: {
				cmsFacility: this.$t('facility'),
				cmsUsers: this.$t('adminMetaTitles.userManagement'),
				cmsEvaluationQuestions: this.$t('evaluationQuestions'),
				cmsSimulationTemplates: this.$t('simulationTemplates'),
				cmsCareers: this.$t('cmsCareers'),
				cmsInterest: this.$t('interest'),
				cmsExpenseCategories: this.$t('expenseCategories'),
				cmsResources: this.$t('resources'),
				cmsLifeEvents: this.$t('lifeEvents'),
				cmsMiscUploads: this.$t('miscUploads')
			},
			titleHeader: this.$t('dashboard'),
			loading: false,
			modalOpened: false,
			isReturnOption: false
		};
	},
	computed: {
		menuOptions() {
			const options = {
				messages: this.$t('messages'),
				students: this.$t('students'),
				resources: this.$t('resources'),
				reporting: this.$t('reporting'),
				simulationManagement: this.$t('simulationManagement'),
				settings: this.$t('settings')
			};

			if (this.isAdmin) {
				const cmsIncluded = {
					cms: 'cms',
					...options
				};
				return cmsIncluded;
			}

			return options;
		},
		visibleMenuOptions() {
			if (this.userData && this.userData.disAllowedUrlPaths) {
				return Object.keys(this.menuOptions)
					.filter(key => !this.userData.disAllowedUrlPaths.includes(key))
					.reduce((obj, key) => {
						obj[key] = this.menuOptions[key];
						return obj;
					}, {});
			}

			return null;
		},
		visibleCmsMenuOptions() {
			if (this.userData && this.userData.disAllowedUrlPaths) {
				return Object.keys(this.menuCmsOptions)
					.filter(key => !this.userData.disAllowedUrlPaths.includes(key))
					.reduce((obj, key) => {
						obj[key] = this.menuCmsOptions[key];
						return obj;
					}, {});
			}

			return null;
		},
		cmsMenuOptionSelected() {
			return this.menuOptions.cms == this.selectedOption;
		}
	},
	methods: {
		onLoadingStartForAdmin() {
			this.loading = true;
		},
		onLoadingStopForAdmin() {
			this.loading = false;
		},
		onMenuChange(option) {
			this.$refs['menu-view'].scrollTop = 0;

			// Prevent multiple requests to be send if there is a route waiting to be resolved
			this.$router.push({ name: option }).then(error => {
				if (error && error.name === 'NavigationDuplicated') {
					this.$store.commit('setIsReturnOption', true);
				}
			});
		},
		onModalOpened() {
			this.modalOpened = true;
		},
		onModalClosed() {
			this.modalOpened = false;
		},
		handleFacilitySelected(value) {
			this.$store.commit('setFacilitySelected', value);
		}
	}
};
</script>
<style lang="scss" scoped>
.admin-section {
	height: 100vh;
	max-height: 100vh;
	min-width: 900px;
	display: flex;
	flex-direction: column;

	header {
		box-shadow: none;

		svg[name='clock'] {
			height: 20px;
			width: 20px;
		}
		.clock {
			color: $font-dark;
			margin-left: 8px;
		}
	}

	.dashboard-bottom-container {
		width: 100%;
		align-items: center;
		background-color: #ffffff;
		box-shadow: 0 15px 30px 0 rgba(0, 148, 240, 0.14);
		border-bottom: 1px solid $container-border;

		.dashboard-bottom {
			display: flex;
			width: 100%;
			justify-content: space-between;
			align-items: center;
			padding: 0 5%;
			background-color: #ffffff;
			font-family: 'RobotoMedium';
			text-transform: capitalize;
			flex-shrink: 0;
			height: 60px;

			.segmented-control-wrapper {
				width: 100%;
				max-width: 1000px;
				margin: auto;
			}
		}
	}
	.content-wrapper {
		flex-grow: 1;
		overflow-y: auto;
		padding: 0 5% 0 5%;
	}

	&.modal-opened {
		.content-wrapper {
			overflow-y: hidden;
		}
	}

	.external-loading-wrapper {
		opacity: 0.6;
		position: fixed;
	}
}
</style>
